import Button from "components/shared/button";
import ListView from "components/shared/list/listView";
import { ListViewType } from "components/shared/list/useListHook";
import { Text } from "components/shared/text";
import { SvgDownload } from "components/svg";
import { usePopup } from "providers/PopupProvider";
import React, { useCallback, useMemo } from "react";
import useTranslation from "utils/hooks/useTranslation";
import { DocumentsPopup } from "../DocumentsPopup";
import { getPanierItemFunctionNameKeyByTag } from "../helpers";

export const EtudeProducts: React.FC<{ solution: Solution }> = ({
  solution,
}) => {
  const { t } = useTranslation();
  const { openPopup, closeLastPopup } = usePopup();
  const panierItems = useMemo(() => {
    return (
      solution?.panier.filter((item) =>
        ["HP", "ballonPrimaire", "stockecs", "stockprep", "exchange"].includes(
          item.tag
        )
      ) || []
    );
  }, [solution]);

  const openDocumentPopup = useCallback(
    (product: Accessoire) => {
      openPopup(
        <DocumentsPopup onClose={() => closeLastPopup()} product={product} />
      );
    },
    [openPopup, closeLastPopup]
  );

  return (
    <group data-direction="column" data-gap="24">
      <Text data-weight="600" data-ellipsis="" data-color="grey-color-dark">
        FO_DOC_DOC_PRODUCT
      </Text>
      <ListView
        data-width="autofit"
        keyField="code"
        view={ListViewType.Grid}
        data-border=""
        data-radius="5"
        dataSource={[...panierItems]}
        itemComponent={({ data }: { data: Accessoire }) => (
          <group
            data-align="center"
            data-space="10"
            data-gap="10"
            data-wrap="no"
          >
            <group
              data-align="center"
              data-wrap="no"
              data-justify="start"
              data-position="left"
              data-length="150"
            >
              <Text>
                {t(getPanierItemFunctionNameKeyByTag(data.tag as any))}
              </Text>
            </group>
            <group data-ratio="1:1" data-length="50" data-shrink="no">
              <picture>
                {data.previewUrl && (
                  <img data-radius="5" src={data.previewUrl} alt="" />
                )}
              </picture>
            </group>
            <group data-direction="column" data-contain="">
              <Text data-weight="700">{data.nom}</Text>
              <Text data-wrap="wrap">{data.description}</Text>
            </group>
            {data.documents?.length > 0 && (
              <group
                data-align="center"
                data-wrap="no"
                data-justify="end"
                data-position="right"
                data-gap="15"
                data-length="150"
              >
                <separator data-vertical=""></separator>
                <Button
                  data-background="white"
                  data-position="right"
                  accent
                  data-height="40"
                  text="FO_PRODUCT_DOCUMENTS"
                  onClick={() => openDocumentPopup(data)}
                >
                  <icon data-svg-size="16">
                    <SvgDownload />
                  </icon>
                </Button>
              </group>
            )}
          </group>
        )}
      />
    </group>
  );
};
